import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import { useParams } from 'react-router-dom';

const AutoJoditEditor = ({ placeholder, subTitle, editorContent, onContentChange }) => {
	const {id} = useParams();
	const editor = useRef(null);
	const [content, setContent] = useState(editorContent);


	const insertDefaultTable = (subTitle) => {
		let tableHtml = '';
		
		if (subTitle === "admissionPhdFullTime") {
			tableHtml=`<table style="border-collapse:collapse;width: 100%;"><tbody>
<tr>
	<td style="width: 20%;">S.No</td>
	<td style="width: 20%;">Name</td>
	<td style="width: 20%;">Department</td>
	<td style="width: 20%;">Supervisor</td>
	<td style="width: 20%;">Category</td></tr>
<tr>
	<td style="width: 20%;">1</td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td></tr></tbody></table>`
		} else if (subTitle === "admissionPhdPartTime") {
			tableHtml=`<table style="border-collapse:collapse;width: 100%;"><tbody>
<tr>
	<td style="width: 20%;">S.No</td>
	<td style="width: 20%;">Name</td>
	<td style="width: 20%;">Department</td>
	<td style="width: 20%;">Supervisor</td>
	<td style="width: 20%;">Category</td></tr>
<tr>
	<td style="width: 20%;">1</td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td>
	<td style="width: 20%;"></td></tr></tbody></table>`
		} else if (subTitle === "awardOfPhdFullTime") {
			tableHtml=`<table style="border-collapse:collapse;width: 100%;"><tbody>
<tr>
	<td style="width: 16.6%;">S.No</td>
	<td style="width: 16.6%;">Name</td>
	<td style="width: 16.6%;">Department</td>
	<td style="width: 16.6%;">Guide Name</td>
	<td style="width: 16.6%;">Viva Date</td>
	<td style="width: 16.6%;">Internal/External</td></tr>
<tr>
	<td style="width: 16.6%;">1</td>
	<td style="width: 16.6%;"></td>
	<td style="width: 16.6%;"></td>
	<td style="width: 16.6%;"></td>
	<td style="width: 16.6%;"></td>
	<td style="width: 16.6%;"></td></tr></tbody></table>`
		} else if (subTitle === "awardOfPhdPartTime") {
			tableHtml=`<table style="border-collapse:collapse;width: 100%;"><tbody>
<tr>
	<td style="width: 16.6%;">S.No</td>
	<td style="width: 16.6%;">Name</td>
	<td style="width: 16.6%;">Department</td>
	<td style="width: 16.6%;">Guide Name</td>
	<td style="width: 16.6%;">Viva Date</td>
	<td style="width: 16.6%;">Internal/External</td></tr>
<tr>
	<td style="width: 16.6%;">1</td>
	<td style="width: 16.6%;"></td>
	<td style="width: 16.6%;"></td>
	<td style="width: 16.6%;"></td>
	<td style="width: 16.6%;"></td>
	<td style="width: 16.6%;"></td></tr></tbody></table>`
		} else if (subTitle === "functions") {
			tableHtml=`<table style="border-collapse:collapse;width: 100%;"><tbody>
<tr>
	<td style="width: 25%;">S.No</td>
	<td style="width: 25%;">Function</td>
	<td style="width: 25%;">Chief Guest</td>
	<td style="width: 25%;">Date</td>
<tr>
	<td style="width: 25%;">1</td>
	<td style="width: 25%;"></td>
	<td style="width: 25%;"></td>
	<td style="width: 25%;"></td></tr></tbody></table>`
		} else if (subTitle === "meetings") {
			tableHtml=`<table style="border-collapse:collapse;width: 100%;"><tbody>
<tr>
	<td style="width: 25%;">Meeting Particulars</td>
	<td style="width: 25%;">Date</td>
<tr>
	<td style="width: 25%;"></td>
	<td style="width: 25%;"></td></tr></tbody></table>`
		}

		setContent(tableHtml);
	};


	const insertImage = (resp) => {
		const imageUrl = `${process.env.REACT_APP_BASE_URL}/api/object/${resp.id}`;
		const imgHtml = `<img src="${imageUrl}" alt="Image" style="max-width: 100%; height: auto;" />`;
		const currentContent = editor.current?.value || content;  
		const updatedContent = currentContent + imgHtml;
		setContent(updatedContent);
		onContentChange(updatedContent);
	};

	// Memoized configuration for JoditEditor
	
	const config = useMemo(() => ({
		readonly: false,
		placeholder: placeholder || '',
		toolbar: {
			buttons: [
				'bold',
				'italic',
				'underline',
				'image', // Include the image button
				'|', // Divider
				'source',
			],
		},
		uploader: {
			insertImageAsBase64URI: false,
			url: `${process.env.REACT_APP_BASE_URL}/api/report/${id}/upload`,
			headers: {
				Authorization: `Bearer ${localStorage.getItem("jwt")}`
			},
			method: 'POST',
			prepareData: (formData) => {
				const files = formData.getAll('files[0]'); 
				formData.delete('files[0]'); 
			
				files.forEach((file) => {
					formData.append('file', file); 
				});
				return formData;
			}
			,
			isSuccess: (resp) => {
				return resp;
			},
			process: (resp) => {
				console.log('File uploaded successfully:', resp);
				insertImage(resp);
				return {}; 
			},
			error: (e) => {
				console.error('Upload error', e);
			}
		},
		events: {
			beforeImage: function(current) {
				return false; 
			},
			'errorMessage': function(message) {
				console.error(message);
			}
		}
	}), [placeholder, id]);

	useEffect(() => {
		if (!editorContent) {
			insertDefaultTable(subTitle);
		} else{
			setContent(editorContent);
		}
	}, [subTitle]);

	const handleContentChange = (newContent) => {
		setContent(newContent);
		onContentChange(newContent);
	  };

	return (
		<JoditEditor
			ref={editor}
			value={content}
			config={config}
			tabIndex={1}
			onBlur={(newContent) => handleContentChange(newContent)}
			onChange={(newContent) => {}}
		/>
	);
};

export default AutoJoditEditor;
